import React, { useEffect, useState, useSyncExternalStore } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import tick from "../Images/Frame 1991425400 (1).png";
import plus from "../Images/fi_2801881 (1).png";
import disable from "../Images/Frame 1991425400 (2).png";
import heart from "../Images/fi_3641323.png";
import myCommunity from "../Images/users-solid.svg";
import comments from "../Images/fi_3641323 (1).png";
import price from "../Images/Frame 1991425400 (3).png";
import profile from "../Images/avatar.jpg";
import locality from "../Images/Frame 1991425400 (5).png";
import subLocality from "../Images/Frame 1991425400 (6).png";
import logout from "../Images/Frame 1991425400 (7).png";
import bell from "../Images/Frame 1991425400 (8).png";
import girlimg from "../Images/beautiful-girl-with-cute-face 1.png";
import cross from "../Images/Vector (24).png";
import settings from "../Images/Vector (25).png";
import HomeService from "../Services/HomeService";
import { toast } from "react-toastify";
import { ChevronDown } from "lucide-react";
const Sidebar2 = ({ sidebarfunc2 }) => {
  const [loginProfile, setLoginProfile] = useState(false);
  const [isCitySubMenuOpen, setIsCitySubMenuOpen] = useState(false);
  const [citiesWithCityDetails, setCitiesWithCityDetails] = useState([]);

  const getLoginProfile = async () => {
    const res = await HomeService.getLoginProfile();
    console.log("sider", res);

    if (res.status) {
      setLoginProfile(res.data);
    }
  };

  const fetchCitiesWithCityDetails = async () => {
    try {
      const res = await HomeService.getCitiesWithCityDetails();
      console.log("city details header", res);
      if (res?.status) {
        setCitiesWithCityDetails(res?.data);
      } else {
        console.log(res);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchCitiesWithCityDetails();
  }, []);



  const navigate = useNavigate();
  const handleLogOut = async () => {
    try {
      const res = await HomeService.handleUserLogout();
      if (res.status) {
        toast.success(res.message);
        localStorage.clear();
        // toast.success(
        //   `Your Max Device Limit is : ${res?.data?.maxDeviceLimit} & Active Device is : ${res?.data?.remainingDevices}`
        // );
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.message);
    }
    localStorage.removeItem("token");
    setLoginProfile(false);
    sidebarfunc2();
    window.location.reload();

    navigate("/", { replace: true });
  };
  // const handleLogOut = () => {
  //   localStorage.removeItem("token");
  //   setLoginProfile(false);
  //   sidebarfunc2();

  //   navigate("/", { replace: true });
  // };

  const dealerDetails = { userId: loginProfile?._id };
  useEffect(() => {
    getLoginProfile();
  }, []);

  const handleClick = () => {
    const a = document.createElement("a");
    a.href = "/profile";
    a.rel = "noopener noreferrer";
    a.click();
  };

  return (
    <>
      <div class="modal_main" onClick={sidebarfunc2}></div>
      <div class="fixed-menu" id="fixed-menu">
        <button class="close-btn" id="close-btn">
          <img onClick={sidebarfunc2} src={cross} alt="" />
        </button>
        {loginProfile ? (
          <div
            class="profile-section"
            onClick={handleClick}
            style={{ cursor: "pointer" }}
          >
            <div class="profile-content">
              <div
                class="profile-wrapper"
                // This style is added by subrata
                style={{
                  width: "50px",
                  height: "50px",
                  borderRadius: "50%",
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#ddd",
                }}
              >
                <img
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover", //This line of code is added by subrata
                  }}
                  src={loginProfile?.image || profile}
                  alt=""
                />
              </div>
              <div class="profile-name">
                <h2>{loginProfile.fullName}</h2>
                <p>{loginProfile.email}</p>
              </div>
            </div>
            <div class="setting-icon">
              <img src={settings} alt="" />
            </div>
          </div>
        ) : (
          ""
        )}

        <div
          style={{
            rowGap: "20px",
            display: "flex",
            flexDirection: "column",
            marginTop: "20px",
          }}
        >
          <NavLink
            to={"/active-properties"}
            className="sidebar_icons_wrapper _old_icons"
          >
            <img className="icon_img" src={tick}></img>
            <NavLink to={"/active-properties"} className="sidebar_icons">
              All Confirm Data
            </NavLink>
          </NavLink>

          <NavLink
            to={"/new-properties"}
            className="sidebar_icons_wrapper _old_icons"
          >
            <img className="icon_img" src={plus}></img>
            <NavLink to={"/new-properties"} className="sidebar_icons">
              Newly Added Data
            </NavLink>
          </NavLink>

          <NavLink
            to={"/deactive-properties"}
            className="sidebar_icons_wrapper _old_icons"
          >
            <img className="icon_img" src={disable}></img>
            <NavLink to={"/deactive-properties"} className="sidebar_icons">
              De active Data
            </NavLink>
          </NavLink>

          <NavLink
            to={"/list-of-favourites"}
            className="sidebar_icons_wrapper _old_icons"
          >
            <img className="icon_img" src={heart}></img>
            <NavLink to={"/list-of-favourites"} className="sidebar_icons">
              List of Favourites
            </NavLink>
          </NavLink>

          <NavLink
            to={"/community-fav-list"}
            className="sidebar_icons_wrapper _old_icons"
          >
            <img className="icon_img" src={heart}></img>
            <NavLink to={"/community-fav-list"} className="sidebar_icons">
              Favourite Communities
            </NavLink>
          </NavLink>

          <NavLink
            to={{
              pathname: "/communitylist",
              state: {
                dealerDetails,
                showInnerState: false,
              },
            }}
            className="sidebar_icons_wrapper old_icons"
          >
            <img className="icon_img" src={myCommunity} alt="Heart Icon" />
            <NavLink
              to={{
                pathname: "/communitylist",
                state: {
                  dealerDetails,
                  showInnerState: false,
                },
              }}
              className="sidebar_icons"
            >
              My Community
            </NavLink>
          </NavLink>

          <div className="sidebar_icons_wrapper new_icons">
            <div
              style={{
                width: "100%",
                cursor: "pointer",
              }}
            >
              <div
                onClick={() => setIsCitySubMenuOpen(!isCitySubMenuOpen)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <i className="fa-solid fa-city icon_img text-secondary"></i>
                  <span className="sidebar_icons">Cities</span>
                </div>

                <ChevronDown
                  size={16}
                  style={{
                    transform: isCitySubMenuOpen
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                    transition: "0.3s",
                  }}
                />
              </div>

              {isCitySubMenuOpen && (
                <div
                  style={{
                    marginLeft: "35px",
                    marginTop: "10px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  {citiesWithCityDetails?.length === 0 ? (
                    <span>No City Found</span>
                  ) : (
                    citiesWithCityDetails?.map((e, i) => (
                      <span
                        key={i}
                        style={{
                          cursor: "pointer",
                          fontSize: "14px",
                        }}
                        onClick={() => {
                          const city = e?.cityData?.name
                            ?.trim()
                            .replace(/\s+/g, "-");

                          navigate(`/city/${city}`, {
                            state: { id: e?.cityData?._id },
                          });

                          sidebarfunc2(); // close sidebar
                        }}
                      >
                        {e?.cityData?.name}
                      </span>
                    ))
                  )}
                </div>
              )}
            </div>
          </div>



          {/* <NavLink to={"/cd"} className="sidebar_icons_wrapper old_icons">
            <img className="icon_img" src={comments}></img>
            <NavLink to={"/cd"} className="sidebar_icons">
              Comments
            </NavLink>
          </NavLink> */}

          <NavLink
            to={"/pricingplan"}
            className="sidebar_icons_wrapper old_icons"
          >
            <img className="icon_img" src={price}></img>
            <NavLink to={"/pricingplan"} className="sidebar_icons">
              Price List
            </NavLink>
          </NavLink>

          <NavLink to={"/profile"} className="sidebar_icons_wrapper old_icons">
            <img className="icon_img" src={profile}></img>
            <NavLink to={"/profile"} className="sidebar_icons">
              Profile
            </NavLink>
          </NavLink>

          {/* <NavLink to={"/cd"} className="sidebar_icons_wrapper old_icons">
            <img className="icon_img" src={locality}></img>
            <NavLink to={"/cd"} className="sidebar_icons">
              Locality Wise Data
            </NavLink>
          </NavLink> */}

          {/* <NavLink to={"/cd"} className="sidebar_icons_wrapper old_icons">
            <img className="icon_img" src={subLocality}></img>
            <NavLink to={"/cd"} className="sidebar_icons">
              Sub Locality
            </NavLink>
          </NavLink> */}

          <NavLink to={"/"} className="sidebar_icons_wrapper new_icons">
            <i class="fa-solid fa-house icon_img text-secondary"></i>
            <NavLink to={"/"} className="sidebar_icons">
              Home
            </NavLink>
          </NavLink>

          <NavLink
            to={"/propertylist"}
            className="sidebar_icons_wrapper new_icons"
          >
            <i class="fa-regular fa-file icon_img text-secondary"></i>
            <NavLink to={"/propertylist"} className="sidebar_icons">
              Properties
            </NavLink>
          </NavLink>

          <NavLink
            to={"/communitylist"}
            className="sidebar_icons_wrapper new_icons"
          >
            <i class="fa-solid fa-users icon_img text-secondary"></i>
            <NavLink to={"/communitylist"} className="sidebar_icons">
              Community
            </NavLink>
          </NavLink>

          <NavLink to={"/profile"} className="sidebar_icons_wrapper new_icons">
            <i class="fa-regular fa-user icon_img text-secondary"></i>
            <NavLink to={"/profile"} className="sidebar_icons">
              Profile
            </NavLink>
          </NavLink>

          <NavLink to={"/blog"} className="sidebar_icons_wrapper new_icons">
            <i class="fa-solid fa-blog icon_img text-secondary"></i>
            <NavLink to={"/blog"} className="sidebar_icons">
              Blog
            </NavLink>
          </NavLink>

          <NavLink
            to={"/pricingplan"}
            className="sidebar_icons_wrapper new_icons"
          >
            <i class="fa-regular fa-money-bill-1 icon_img text-secondary"></i>
            <NavLink to={"/pricingplan"} className="sidebar_icons">
              Price
            </NavLink>
          </NavLink>

          <NavLink to={"/career"} className="sidebar_icons_wrapper new_icons">
            <i class="fa-solid fa-users-rectangle icon_img text-secondary"></i>
            <NavLink to={"/career"} className="sidebar_icons">
              Careers
            </NavLink>
          </NavLink>

          {/* <NavLink
            to={"/cd"}
            className="sidebar_icons_wrapper sidebar_whatsapp_div "
          >
            <i class="fa-brands fa-whatsapp text-secondary icon_img"></i>
            <NavLink to={"/cd"} className="sidebar_icons">
              Chat On Whatsapp
            </NavLink>
          </NavLink> */}

          {/* <NavLink
            to={"/cd"}
            className="sidebar_icons_wrapper sidebar_call_div"
          >
            <i class="fa-solid fa-phone text-secondary icon_img"></i>
            <NavLink to={"/cd"} className="sidebar_icons">
              Call Us
            </NavLink>
          </NavLink> */}

          {/* <NavLink to={"/profile"} className="sidebar_icons_wrapper">
            <img className="icon_img" src={logout}></img>
            <NavLink
              to={"/profile"}
              className="sidebar_icons"
              onClick={handleLogOut}
            >
              {loginProfile ? "Logout" : "Login"}
            </NavLink>
          </NavLink> */}
          <div
            className="sidebar_icons_wrapper"
            // onClick={handleLogOut}
            style={{ cursor: "pointer" }}
          >
            <img className="icon_img" src={logout} alt="logout" />
            {loginProfile ? (
              <span className="sidebar_icons" onClick={handleLogOut}>
                Logout
              </span>
            ) : (
              <span
                className="sidebar_icons"
                onClick={() => {
                  navigate("/profile");
                }}
              >
                Login
              </span>
            )}
            {/* <span className="sidebar_icons">
              {loginProfile ? "Logout" : "Login"}
            </span> */}
          </div>
        </div>

        <div class="upgrade-wrapper">
          <div class="upgrade-div">
            <h2 class="upgrade-heading">UPGRADE NOW</h2>
            <p>Get Premium Community</p>
            <button class="upgrade-btn">Upgrade Now</button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar2;
